module.exports = __webpack_public_path__ + "static/media/bata.48024a22.png";